module.exports = __webpack_public_path__ + "static/media/AvenirNext-UltraLightItalic.3b25e1a6.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/AvenirNext-UltraLightItalic.woff2
// module id = 1817
// module chunks = 0